import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Certifications from "./pages/Certifications";
import Infrastructure from "./pages/Infrastructure";
import ExportMarkets from "./pages/ExportMarkets";
import Contact from "./pages/Contact";
import ExportTerms from "./pages/ExportTerms";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/infrastructure" element={<Infrastructure />} />
            <Route path="/export-markets" element={<ExportMarkets />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/export-terms" element={<ExportTerms />} />
          </Routes>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
